import React from "react";

const PieChart = ({ progress }) => {
  const pieStyle = {
    background: `conic-gradient(#4caf50 ${progress}%, #ccc 0)`,
    borderRadius: "50%",
    width: "60px",
    height: "60px",
  };

  return (
    <div style={{ position: "relative", width: "60px", height: "60px" }}>
      <div style={pieStyle}></div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#fff",
          borderRadius: "50%",
          width: "60%",
          height: "60%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.7em",
        }}
      >
        <strong>{progress}%</strong>
      </div>
    </div>
  );
};

export default PieChart;
